import React from "react";
import "react-awesome-lightbox/build/style.css";
import {
  Card,
  Container,
  Row,
  Col,
  Spinner,
} from "react-bootstrap";
import PDFExport from "../../../helper/export-pdf";
// import Map from "../../../../_metronic/layout/components/mapbox";

import overlayFactory from "react-bootstrap-table2-overlay";
import Axios from "axios";
import moment from "moment";
import BootstrapTable from "react-bootstrap-table-next";
import { sortCaret } from "../../../../_metronic/_helpers";


import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

/* Styles */
import "../../../../styles/app/pages/CampaingPreview.scss";

function sendNotification(body) {
  return Axios.post(process.env[`REACT_APP_${process.env.REACT_APP_ENV.toUpperCase()}_URL`] + "/v1/notification/", body)
}

function ActionsColumnFormatter(
  cellContent,
  row,
  rowIndex,
  { handleShow, hideTrace, current, allTraces, usersTraces, state }
) {
  const isHide = !usersTraces.filter(
    (traces) => traces[0]?.user_id === row.uid
  ).length;
  const isDisabled = !allTraces.filter(
    (traces) => traces[0]?.user_id === row.uid
  ).length;
  const url = `https://gto-call-bridge.herokuapp.com/?supervisor=${current.name}&uid=${current.uid}&user=${row.uid}&nameagent=${row.name}`
  return (
    <>
      <button
        title="Toggle Trace"
        className={`btn btn-${isHide ? "danger" : "warning"} mx-1`}
        onClick={() => hideTrace(row.uid)}
        disabled={isDisabled}
      >
        {isHide ? "Hide" : "Show"}
      </button>
      {" "}
      <button
        onClick={() => {
          sendNotification({
            message: "You have one call incoming",
            platform: "users",
            title: "VideoCall Incoming",
            uid: row.uid,
            url: `https://gto-call-bridge.herokuapp.com/?supervisor=${current.name}&uid=${row.uid}&from=${current.uid}&nameagent=${row.name}`,
            call: true

          });
          window.open(url, '_blank');

        }}
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        title="Call Agent"
        className="btn btn-info"
        disabled={String(state ?? "").toUpperCase() !== "ON GOING"}
      >
        Call
      </button>
    </>
  );
}
function ColorColumnFormatter(cellContent, row, rowIndex, { traces }) {
  const _traces = traces.map((trace) => trace[0] || {});
  const [color] = _traces
    .filter((trace) => trace.user_id === row.uid)
    .map((r) => r.color);
  if (!color) {
    return null
  }
  return (
    <>
      <hr
        style={{
          height: "5px",
          width: "30px",
          borderTop: `5px solid ${color || "#FFF"}`,
        }}
      />
    </>
  );
}


export default function Agents(props) {

  const columns = [
    {
      dataField: "count",
      text: "No",
      headerStyle: {
        width: "80px",
      },
    },
    {
      dataField: "color",
      text: "color",
      formatter: ColorColumnFormatter,
      formatExtraData: props.controllers,
      classes: "text-center pr-0",
      headerClasses: "text-center pr-3",
      style: {
        maxWidth: "20px",
      },
    },
    {
      dataField: "name",
      text: "Agent Name ",
      sort: true,
      sortCaret: sortCaret,
      headerStyle: {
        width: "250px",
      },
    },
    {
      dataField: "action",
      text: "Actions",
      formatter: ActionsColumnFormatter,
      formatExtraData: props.controllers,
      classes: "w-100 text-right pr-0",
      headerClasses: "text-right pr-3",

    },
  ];


  return (
    <div className="pt-1 pr-1">
      <Card className="pt-4 rounded-xl shadow-sm" style={{ minHeight: "600px" }}>
        <Container fluid >
          <br />

          <Row className="w-100 justify-content-between p-2">
            <div className="col-6 w-100 justify-content-end d-flex ">
              <h1>
                AGENTS
              </h1>
            </div>
            <PDFExport columns={["no", "name"]} data={props.users.map((doc, i) => ({ no: Number(i) + 1, ...doc }))} name="agents" sign={props.campaign.name + "\n" + moment(props.campaign.start_date).format("MMMM/DD/YY") + "-" + moment(props.campaign.end_date).format("MMMM/DD/YY")}>
              <button className="btn btn-warning font-weight-bolder mx-2">
                Export Data
              </button>
            </PDFExport>
          </Row>

          <Row>
            <Col>
              {!props.queryng ?

                <BootstrapTable
                  wrapperClasses="table-responsive"
                  bordered={false}
                  classes="table table-head-custom table-vertical-center"
                  bootstrap4
                  hover
                  striped
                  keyField="uid"
                  data={props.users.map((doc, i) => ({ count: Number(i) + 1, ...doc }))}
                  columns={[ ...columns]}
                  overlay={overlayFactory({ spinner: true })}
                  noDataIndication={<div className="mr-2 text-muted">No records found</div>}
                ></BootstrapTable>
                : (
                  <Spinner animation="border" role="status">
                    <span className="sr-only">Loading...</span>
                  </Spinner>
                )}
            </Col>
          </Row>
        </Container>
      </Card>
    </div>

  );
}
